import { Box, Tabs, Tab } from '@mui/material'
import { MdKeyboardArrowLeft } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router-dom'
import { IconButton, Loading, TabPanel } from 'components'
import { PageContent } from 'layout'
import { useLayoutContext } from 'layout/layout.context'
import { useLoadOrder } from 'modules/orders/hooks'
import { useEffect, useState } from 'react'
import { General, Items, Payments, Trackings } from './tabs'
import { Freight } from './tabs/freight'
import { Charge } from './tabs/Charge'

export const OrderDetailsPage = () => {
  const [value, setValue] = useState(0)
  const navigation = useNavigate()
  const { id } = useParams()
  const { setBreadcrumbs } = useLayoutContext()

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const { data: order, isLoading } = useLoadOrder(id)

  useEffect(() => {
    const code = order?.orderId || order?.proposalId || id || ''
    setBreadcrumbs([
      { label: 'Início', to: '/home' },
      { label: 'Pedidos', to: '/orders' },
      { label: code, copyText: code }
    ])
    return () => setBreadcrumbs([])
  }, [order, id])

  if (isLoading)
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Loading />
      </div>
    )

  return (
    <div>
      <PageContent>
        <>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              width: '100%',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <IconButton onClick={() => navigation('/orders')} sx={{ mr: 1 }}>
              <MdKeyboardArrowLeft size={24} color="#565656" />
            </IconButton>
            <Tabs value={value} onChange={handleChange} variant="scrollable">
              <Tab label="Geral" />
              <Tab label="Frete" />
              <Tab label="Carga" />
              <Tab label="Pagamentos" />
              <Tab label="Itens" />
              <Tab label="Acompanhamentos" />
            </Tabs>
          </Box>
          <Box>
            <TabPanel value={value} index={0}>
              <General order={order} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Freight order={order} />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Charge order={order} />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <Payments order={order} />
            </TabPanel>
            <TabPanel value={value} index={4}>
              <Items order={order} />
            </TabPanel>
            <TabPanel value={value} index={5}>
              <Trackings order={order} />
            </TabPanel>
          </Box>
        </>
      </PageContent>
    </div>
  )
}

export default OrderDetailsPage
